export default __webpack_public_path__ + "static/tcofs-ew-wallpaper-1080x1920-dc97c6ed6b11689974106c31ec0664ed.jpg";